import { hotList } from '@/mocks/homeData';

export default function HotList() {
  return (
    <div className="h-full rounded-lg border border-background-300 bg-background-100 p-5 flex flex-col">
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
          <span className="w-5 h-5 flex items-center justify-center text-primary-600">
            <i className="ri-fire-line text-lg"></i>
          </span>
          深扒热榜
        </h3>
        <span className="text-[11px] text-foreground-500 font-label">近 24 小时</span>
      </div>

      <ol className="mt-4 divide-y divide-background-200">
        {hotList.map((item, idx) => (
          <li key={item.id}>
            <a href="#feed" className="flex items-start gap-3 py-3 group">
              <span
                className={`mt-0.5 w-6 h-6 shrink-0 rounded-md flex items-center justify-center font-label text-xs ${
                  idx === 0 ? 'bg-primary-500 text-background-50' : idx < 3 ? 'bg-primary-100 text-primary-700' : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>
              <span className="flex-1 min-w-0">
                <span className="block text-sm leading-snug text-foreground-800 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </span>
                <span className="mt-1 block text-[11px] text-foreground-500 font-label">{item.views} 次翻牌</span>
              </span>
            </a>
          </li>
        ))}
      </ol>

      <a
        href="#feed"
        className="mt-auto pt-4 flex items-center justify-center gap-1.5 h-10 rounded-md border border-background-300 text-sm font-label text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
      >
        查看完整榜单
        <i className="ri-arrow-right-line"></i>
      </a>
    </div>
  );
}